'use client';
import { segmentWEBKey, useIntl, useSettings } from '@capsicum/common';
import { ConsentCookieBanner } from '@socios/consent-cookie-banner-web';
import { atom, useAtomValue } from 'jotai';
import styled from 'styled-components';

import { useRouter } from '../../../hooks/router/useCustomRouter';
import { TUTORIAL_POPOVER_ZINDEX } from '../../../hooks/tutorial/useTutorialStyles';
import { env } from '../../../util/env';

export const displayCookieConsentBannerAtom = atom<boolean>(true);

export const COOKIE_CONSENT_BANNER_ZINDEX = TUTORIAL_POPOVER_ZINDEX + 1;

const segmentKey = segmentWEBKey[(env?.NEXT_PUBLIC_ENV || 'integration') as keyof typeof segmentWEBKey];

export const CookieConsentBanner = (): JSX.Element | null => {
	const { $t } = useIntl();
	const { pathname } = useRouter();
	const displayCookieConsentBanner = useAtomValue(displayCookieConsentBannerAtom);
	const {
		settings: { privacyPolicyLink }
	} = useSettings();

	const texts = {
		acceptAll: $t('cookieConsent.acceptAll'),
		bannerContent: $t('cookieConsent.bannerContent'),
		bannerSubContent: $t('cookieConsent.configure'),
		cancelDialogContent: $t('cookieConsent.cancelDialogContent'),
		cancelDialogTitle: $t('cookieConsent.cancelDialogTitle'),
		denyAll: $t('cookieConsent.denyAll'),
		policyLink: $t('cookieConsent.policyLink'),
		preferencesDialogContent: $t('cookieConsent.preferencesDesc'),
		preferencesDialogTitle: $t('cookieConsent.preferencesTitle')
	};

	if (!displayCookieConsentBanner || pathname.startsWith('/demo/') || pathname.includes('/go/')) return null;

	return (
		<S.ConsentBanner>
			<ConsentCookieBanner policyUrl={privacyPolicyLink} segmentKey={segmentKey} texts={texts} />
		</S.ConsentBanner>
	);
};

namespace S {
	export const ConsentBanner = styled.div`
		position: fixed;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: ${COOKIE_CONSENT_BANNER_ZINDEX};
	`;
}
